import { setComponentMapOverrides } from '@jutro/uiconfig';
import { SgWizardPageTemplate } from 'saga-modules';
import SgRenewalSummaryPage from './pages/SgRenewalSummaryPage/SgRenewalSummaryPage';
import SgRenewalDeclarationsPage from './pages/SgRenewalDeclarationsPage/SgRenewalDeclarationsPage';
import SgRenewalPaymentPage from './pages/SgRenewalPaymentPage/SgRenewalPaymentPage';
import SgRenewalConfirmationPage from './pages/SgRenewalConfirmationPage/SgRenewalConfirmationPage';
import SgRenewalChangesPage from './pages/SgRenewalChangesPage/SgRenewalChangesPage';
import SgRenewalAddonsPage from './pages/SgRenewalAddonsPage/SgRenewalAddonsPage';
import SgRenewalQuotePage from './pages/SgRenewalQuotePage/SgRenewalQuotePage';

setComponentMapOverrides(
    {
        SgRenewalSummaryPage: { component: 'SgRenewalSummaryPage' },
        SgRenewalDeclarationsPage: { component: 'SgRenewalDeclarationsPage' },
        SgRenewalPaymentPage: { component: 'SgRenewalPaymentPage' },
        SgRenewalConfirmationPage: { component: 'SgRenewalConfirmationPage' },
        SgRenewalChangesPage: { component: 'SgRenewalChangesPage' },
        SgRenewalAddonsPage: { component: 'SgRenewalAddonsPage' },
        SgRenewalQuotePage: { component: 'SgRenewalQuotePage' }
    },
    {
        SgRenewalSummaryPage,
        SgWizardPageTemplate,
        SgRenewalDeclarationsPage,
        SgRenewalPaymentPage,
        SgRenewalConfirmationPage,
        SgRenewalChangesPage,
        SgRenewalAddonsPage,
        SgRenewalQuotePage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as RenewalWizard } from './SgRenewalWizard';
